import { render, staticRenderFns } from "./SpfiCreate.vue?vue&type=template&id=37d3deec&scoped=true"
import script from "./SpfiCreate.vue?vue&type=script&lang=js"
export * from "./SpfiCreate.vue?vue&type=script&lang=js"
import style0 from "./SpfiCreate.vue?vue&type=style&index=0&id=37d3deec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d3deec",
  null
  
)

export default component.exports